// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export * from "./concat.common.js";
